module.exports = __webpack_public_path__ + "c4cebd85bb519f7aa3546bce231495c1.svg";